<div class="page-container">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <h1 class="main-heading">
      <fa-icon [icon]="faUsers" />
      Colour By Model Detail
    </h1>
    <app-navpath />
  </div>
  <div class="mb-2 flex w-full flex-wrap gap-1 md:w-fit">
    <button *ngIf="mode === 'Add'" class="shorter-btn misc-btn" (click)="onSave()">
      <fa-icon [icon]="faPlus" class="mr-1" />Create
    </button>
    <button *ngIf="mode === 'Edit'" class="shorter-btn misc-btn" (click)="onSave()">
      <fa-icon [icon]="faPencil" class="mr-1" />Update
    </button>
    <button class="shorter-btn clear-btn" (click)="onCancel()">
      <fa-icon [icon]="faBan" class="mr-1" />Cancel
    </button>
  </div>
  <div class="content-container">
    <app-data-form 
      [dataFields]="formFields" 
      (updateFields_child)="handleFormChange($event)">
    </app-data-form>
  </div>
</div>
